import { render, staticRenderFns } from "./ticketsTable.vue?vue&type=template&id=f99cd7a4"
import script from "./ticketsTable.vue?vue&type=script&lang=js"
export * from "./ticketsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports